/**
 * The model card's measured error rates at the reference point, as constants for the interface (DESIGN UD-18, P3).
 * Nothing here is computed in the UI: each figure is copied from `docs/model-card/<id>.md` and `data/oof/c3-claims.json`,
 * and test/unit/model-card-figures.test.ts checks every row against the claims table and the pooled figure against the
 * model card, so they cannot drift from the shipped model without failing a test. Update this file with the model.
 */

export interface StratumFigure {
	stratum: string;
	label: string;
	n: number;
	flagged: number;
	/** One-sided 95% upper bound on the false-positive rate, as a fraction. */
	bound: number;
}

export const MODEL_CARD_FIGURES = {
	modelId: 'c3-gam-422fb519',
	/** Nested out-of-fold, all human strata and lengths, at the reference point (model card §"What it claims"). */
	pooledHuman: { n: 2795, flagged: 11, bound: 0.007 },
	/** The held-out final slice, scored once after sign-off (model card §"Final slice"). */
	finalSliceHuman: { n: 2487, flagged: 7, bound: 0.005 },
	/** Per human stratum, all lengths, at the reference point (`data/oof/c3-claims.json`, kind fpr, strict1, bin all). */
	strata: [
		{ stratum: 'H-ACA', label: 'academic', n: 478, flagged: 2, bound: 0.013112056620957345 },
		{
			stratum: 'H-ESL',
			label: 'English as a second language',
			n: 286,
			flagged: 1,
			bound: 0.016551314075086775,
		},
		{
			stratum: 'H-FIC-GEN',
			label: 'genre fiction',
			n: 508,
			flagged: 2,
			bound: 0.01243192387624286,
		},
		{
			stratum: 'H-FIC-LIT',
			label: 'literary fiction',
			n: 384,
			flagged: 5,
			bound: 0.027409176420766464,
		},
		{ stratum: 'H-NEWS', label: 'news', n: 298, flagged: 0, bound: 0.010398044860450817 },
		{ stratum: 'H-NF', label: 'non-fiction', n: 348, flagged: 0, bound: 0.008724824603073274 },
		{
			stratum: 'H-TRN',
			label: 'human translations',
			n: 162,
			flagged: 1,
			bound: 0.029543564851086085,
		},
		{ stratum: 'H-WEB', label: 'web text', n: 331, flagged: 0, bound: 0.009009717721385292 },
	] as StratumFigure[],
	/** The widest measured human cell named in the model card (amateur forum fiction, all lengths). */
	widestCell: { label: 'amateur forum fiction', n: 120, flagged: 1, bound: 0.039 },
} as const;
